import React from 'react';
import { Button, Grid, OutlinedInput, InputLabel, Stack, FormHelperText, Box } from '@mui/material';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import * as Yup from 'yup';
import { DeleteIcon } from 'assets/svgs/index';
import { useTheme } from '@mui/material/styles';

const Playbook = ({ handleNext, handleBack, playbook, setPlaybook, isDemoCompany = false }) => {
  const theme = useTheme();
  // const validationSchema = Yup.object().shape({
  //   tenant_values: Yup.string().required('Value is required'),
  //   tenant_mission: Yup.string().required('Mission is required'),
  //   tenant_vision: Yup.string().required('Vision is required')
  // });

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm({
    // resolver: yupResolver(validationSchema),
    defaultValues: {
      // tenant_values: '',
      tenant_playbook_values: [
        {
          tenant_values: ''
        }
      ],
      tenant_mission: '',
      tenant_vision: ''
    }
  });
  const onSubmit = (values) => {
    setPlaybook(values);
    handleNext();
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tenant_playbook_values'
  });

  React.useEffect(() => {
    if (playbook) {
      reset({
        tenant_playbook_values: playbook?.tenant_playbook_values,
        tenant_mission: playbook?.tenant_mission,
        tenant_vision: playbook?.tenant_vision
      });
      // setValue('tenant_values', playbook?.tenant_playbook_values);
      // setValue('tenant_mission', playbook?.tenant_mission);
      // setValue('tenant_vision', playbook?.tenant_vision);
    }
  }, [playbook]);

  return (
    <form
      noValidate
      onSubmit={handleSubmit(onSubmit)}
    >
      <Box>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <Stack spacing={1}>
              <InputLabel htmlFor="mission">Mission</InputLabel>
              <Controller
                name="tenant_mission"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <OutlinedInput
                    multiline
                    rows={3}
                    type="text"
                    placeholder="Mission"
                    id="mission"
                    value={field.value}
                    name={field.name}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    fullWidth
                    error={Boolean(errors.tenant_mission)}
                    disabled={isDemoCompany}
                  />
                )}
              />
              {errors.tenant_mission?.message && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-tenant_mission"
                >
                  {errors.tenant_mission?.message}
                </FormHelperText>
              )}
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Stack spacing={1}>
              <InputLabel htmlFor="tenant_vision">Vision</InputLabel>
              <Controller
                name="tenant_vision"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <OutlinedInput
                    multiline
                    rows={3}
                    type="text"
                    placeholder="Vision"
                    id="tenant_vision"
                    value={field.value}
                    name={field.name}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    fullWidth
                    error={Boolean(errors.tenant_vision)}
                    disabled={isDemoCompany}
                  />
                )}
              />
              {errors.tenant_vision?.message && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-tenant_vision"
                >
                  {errors.tenant_vision?.message}
                </FormHelperText>
              )}
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Stack spacing={1}>
              <InputLabel htmlFor="tenant_values">Values</InputLabel>
              {fields?.map((item, index) => (
                <Stack
                  spacing={1}
                  sx={{ mb: 2 }}
                  key={item?.id + 'tenant_playbook_values'}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Controller
                      name={`tenant_playbook_values[${index}].tenant_values`}
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <OutlinedInput
                          id={`tenant_playbook_values-${index}`}
                          type="text"
                          value={field.value}
                          name={field.name}
                          onBlur={field.onBlur}
                          autoComplete={'on'}
                          onChange={field.onChange}
                          placeholder="Values"
                          fullWidth
                          error={Boolean(errors.tenant_playbook_values && errors.tenant_playbook_values[index]?.tenant_values)}
                          disabled={isDemoCompany}
                        />
                      )}
                    />
                    {index > 0 && !isDemoCompany && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        sx={{ minHeight: '36px', minWidth: '36px' }}
                        onClick={() => remove(index)}
                      >
                        <DeleteIcon stroke={theme.palette.secondary.main} />
                      </Button>
                    )}
                  </Box>
                  {errors.tenant_playbook_values && errors.tenant_playbook_values[index]?.tenant_values?.message && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-tenant_playbook_values"
                    >
                      {errors.tenant_playbook_values[index]?.tenant_values?.message}
                    </FormHelperText>
                  )}
                </Stack>
              ))}
              {/* <Controller
                name="tenant_values"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <OutlinedInput
                    multiline
                    rows={3}
                    type="text"
                    placeholder="Values"
                    id="tenant_values"
                    value={field.value}
                    name={field.name}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    fullWidth
                    error={Boolean(errors.tenant_values)}
                  />
                )}
              />
              {errors.tenant_values?.message && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-tenant_values"
                >
                  {errors.tenant_values?.message}
                </FormHelperText>
              )} */}
            </Stack>
          </Grid>
          <Grid xs={12}>
            <Stack
              direction="row"
              justifyContent="flex-end"
              sx={{ my: 2 }}
            >
              <Box></Box>
              {!isDemoCompany && (
                <Button
                  variant="outlined"
                  color="secondary"
                  type="button" // Use type="button" for adding
                  onClick={() =>
                    append({
                      tenant_values: ''
                    })
                  }
                >
                  Add Values
                </Button>
              )}
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={1}
            >
              <Button
                onClick={() => {
                  handleBack();
                  setPlaybook(getValues());
                }}
                variant="outlined"
                color="secondary"
                sx={{ width: '200px', height: '40px' }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{ width: '200px', height: '40px' }}
              >
                Next
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default Playbook;
